import React from "react";
import { useAppContext } from "../../../../../lib/appContext";
import { StyledTypography } from "./StyledTypography";

export const Title: React.FC = () => {
  const { businessUnitConfig } = useAppContext();
  return (
    <StyledTypography variant="subtitle1" component="h2" gutterBottom={true}>
      {businessUnitConfig.name}
    </StyledTypography>
  );
};
